module.exports = __webpack_public_path__ + "media/images/O blanc-4d60aa0599a2812201773682286fa050.svg";